// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_IMAGE_PROVIDER } from './select-image-provider.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_IMAGE_PROVIDER);

export const selectImageProviderListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectImageProviderListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectImageProviderListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


